module.exports = __webpack_public_path__ + "img/logo-hs.fd2bcca5.svg";